import type {
	CheckoutOrderStatusResponse,
	CheckoutsOrdersNewResponse,
	CheckoutsOrdersRequest,
	ConfirmCheckoutOrderResponse,
	SurveyFormRequest,
	UserCheckoutOptionsResponse,
} from '@/types/checkout';
import type { ErrorResponse } from '@/types/common';

export const postCheckoutsOrdersAPI = (payload: Partial<CheckoutsOrdersRequest>) => {
	return useRequest<CheckoutsOrdersNewResponse, ErrorResponse>(
		CHECK_OUTS_ORDERS_ENDPOINT,
		REQUEST_METHOD.POST,
		{
			...payload,
		},
		{},
		{},
		true,
	);
};

export const getUserCheckoutOptionsAPI = (userId: number, eventId: number) => {
	const endPoint = `${USERS_ENDPOINT}/${userId}/account/checkout-options`;
	return useRequest<UserCheckoutOptionsResponse, ErrorResponse>(
		endPoint,
		REQUEST_METHOD.GET,
		{},
		{
			eventId,
		},
		{},
		true,
	);
};

export const patchCheckoutOrderBuyerInfoByOrderIdAPI = (
	orderId: string,
	payload: Partial<CheckoutsOrdersRequest>,
) => {
	return useRequest<{}, ErrorResponse>(
		`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/buyer-info`,
		REQUEST_METHOD.PATCH,
		payload,
		{},
		{},
		true,
	);
};

export const postConfirmCheckoutsOrdersAPI = ({
	orderId,
	paymentMethodId,
	callbackUrl,
}: {
	orderId: string
	paymentMethodId?: string
	callbackUrl?: string
}) => {
	return useRequest<ConfirmCheckoutOrderResponse, ErrorResponse>(
		`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/confirm`,
		REQUEST_METHOD.POST,
		{
			...(paymentMethodId ? { paymentMethodId } : {}),
			...(paymentMethodId ? { paymentMethodType: PAYMENT_METHOD.CREDIT_CARD } : {}),
			...(callbackUrl ? { callbackUrl } : {}),
		},
		{},
		{},
		true,
	);
};

export const getCheckoutOrdersStatusAPI = (orderId: string) => {
	return useRequest<CheckoutOrderStatusResponse, ErrorResponse>(
		`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/status`,
		REQUEST_METHOD.GET,
		{},
		{},
		{},
		true,
	);
};

export const patchSurveyFormByOrderIdAPI = (orderId: string, payload: SurveyFormRequest) => {
	return useRequest<{}, ErrorResponse>(
		`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/survey`,
		REQUEST_METHOD.PATCH,
		{
			formId: payload.formId,
			userResponse: payload.data,
		},
		{},
		{},
		true,
	);
};
